import React from 'react'
import { i18n } from '../../validator'
import Button from '../../front/components/shared/sn-button'
import Configurator from '../../configurator'

@i18n()
export default class BrowserBar extends Configurator {

    state = {
        hideBar: false,
    }

    /**
     * Hide browser bar for a while
     */
    hideBar = () => {
        this.setState({ hideBar: true })
    }

    render() {
        const isIE = navigator.userAgent.match(/MSIE|Trident/)

        if (!isIE || this.state.hideBar) {
            return null
        }

        const { REACT_APP_BROWSERS_IMAGES_FOLDER } = this.config
        const { t } = this.props

        const browsersData = {
            chrome: {
                imagePath: `${REACT_APP_BROWSERS_IMAGES_FOLDER}chrome.png`,
                alternative: 'chrome',
                link: 'https://www.google.com/chrome/',
                text: t('browsers.chrome'),
            },
            safari: {
                imagePath: `${REACT_APP_BROWSERS_IMAGES_FOLDER}safari.png`,
                alternative: 'safari',
                link: 'https://www.apple.com/lae/safari/',
                text: t('browsers.safari'),
            },
            firefox: {
                imagePath: `${REACT_APP_BROWSERS_IMAGES_FOLDER}firefox.png`,
                alternative: 'firefox',
                link: 'https://www.mozilla.cz/',
                text: t('browsers.firefox'),
            },
            opera: {
                imagePath: `${REACT_APP_BROWSERS_IMAGES_FOLDER}opera.png`,
                alternative: 'opera',
                link: 'http://www.opera.com/',
                text: t('browsers.opera'),
            },
            edge: {
                imagePath: `${REACT_APP_BROWSERS_IMAGES_FOLDER}edge.png`,
                alternative: 'edge',
                link: 'https://www.microsoft.com/en-us/windows/microsoft-edge',
                text: t('browsers.edge'),
            },
        }

        return (
            <div className="Browser-bar">
                <div className="Browser-bar__text">
                    <div className="Browser-bar__text__in">
                        {t('browserLegacyMessage')}
                    </div>
                    {Object.values(browsersData).map((browser, index) => (
                        <div key={index} className="Browser-bar__browser">
                            <img src={browser.imagePath} alt={browser.alternative} />
                            <a className="Browser-bar__link" href={browser.link}>
                                {browser.text}
                            </a>
                        </div>
                    ))}
                </div>

                <Button
                    className="btn btn-outline-color-neutral btn-circle Browser-bar__button"
                    onClick={this.hideBar}
                >
                    {t('close')}
                </Button>
            </div>
        )
    }
}
